export const tr = {
    'clicks-forecast': 'Tıklama tahmini',
    'cost-forecast': 'Harcama tahmini, {currency}',
    name: 'Reklam alanı'
};
